import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client';
import type { GfaLocaleServiceV1 } from '../app/feature-service-types';
import packageJson from '../../package.json';

export const DEFAULT_OMNIGRAPH_ENDPOINT_URL = 'https://omnigraph.audi.com/graphql';

export const createApolloClient = (_locale: GfaLocaleServiceV1) => {
  const client = new ApolloClient({
    ssrMode: true,
    link: createHttpLink({
      uri: process.env.REACT_APP_OMNIGRAPH_ENDPOINT_URL || DEFAULT_OMNIGRAPH_ENDPOINT_URL,
      headers: {
        'apollographql-client-name': packageJson.name,
        'apollographql-client-version': packageJson.version,
      },
    }),
    cache: new InMemoryCache(),
    defaultOptions: {
      query: { fetchPolicy: 'no-cache' },
    },
  });

  return client;
};
